export default {
  // 新增储运事件
  insertYgnEvent: '/ygsjzs/ygnEvent/insertYgnEvent',
  //  修改储运事件
  updateYgnEvent: '/ygsjzs/ygnEvent/updateYgnEvent',
  // 删除储运事件
  deleteYgnEvent: '/ygsjzs/ygnEvent/deleteYgnEvent',

  // 查询储运事件详情
  selectYgnEventByEventId: '/ygsjzs/ygnEvent/selectYgnEventByEventId',
  // 分页查询储运事件列表

  selectYgnEventByPage: '/ygsjzs/ygnEvent/selectYgnEventByPage',
  // 物理删除储运事件记录
  deleteDataYgnEventRecord: '/ygsjzs/ygnEvent/deleteDataYgnEventRecord',
  // 新增储运事件记录
  insertYgnEventRecord: '/ygsjzs/ygnEvent/insertYgnEventRecord'
}
